
<template>
    <div class="center">
        <vs-row class="mb-3" v-if="trasladarSaldoFavorGeneral && JSON.parse(personaRol).tipoUserPrincipal == 'Personal central - TI'">
            <vs-col sm="12" lg="5">
                <div class="d-flex">
                    <md-card class="text-center md-warn" md-with-hover>
                        <md-ripple>
                            <md-card-header>
                                <div class="md-title">{{trasladarSaldoFavorGeneral |currency}}</div>
                                <div class="md-subhead mb-2">
                                    <p v-for="option in ciclosEscolares" :key="option.id" class="mb-0">
                                        <span v-if="option.id == cicloEscolar">Saldo a favor en {{option.text}}</span>
                                    </p>
                                </div>
                                <vs-button
                                    class="m-auto mt-2"
                                    dark
                                    shadow
                                    @click="activeTransladarSaldos = ! activeTransladarSaldos, selectedRow = {saldo_a_favor: trasladarSaldoFavorGeneral}"
                                >
                                    Transladar saldo
                                </vs-button>
                            </md-card-header>
                        </md-ripple>
                    </md-card>
                </div>
            </vs-col>
        </vs-row>
        <div class="d-flex mb-3" v-if="trasladarSaldoFavor.length && JSON.parse(personaRol).tipoUserPrincipal == 'Personal central - TI'">
            <h5 :class="tabName == 'balance' ? 'mayusculasSelect' : 'notSeleccionado'" @click="tabName = 'balance'">
                <strong>Balance general</strong>
            </h5>
            <h5 :class="tabName == 'saldo' ? 'mayusculasSelect' : 'notSeleccionado'" @click="tabName = 'saldo'">
                <strong>Saldo a favor</strong>
            </h5>
        </div>
        <h5 v-else class="mayusculas mb-3">
            <strong>Balance general</strong>
        </h5>
        <div class="table-responsive" v-if="tabName == 'balance'">
            <table style='position: relative' class="table tableBalance" :key="refrescar">
                <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col">Concepto</th>
                    <th scope="col">Fecha Vigencia / Aplicación</th>
                    <th scope="col">Cargo</th>
                    <th scope="col">Abono</th>
                    <th scope="col">Saldo</th>
                </tr>
                </thead>
                <tbody v-for="(tr, i) in balance" :key="i">
                    <tr class="accordion-toggle collapsed"  v-if="balance">
                        <td :style="tr.desglose[0] ? 'cursor: pointer;' : ''" :id="'accordion' + i" data-toggle="collapse" :data-parent="'#accordion' + i" :href="'#collapseOne' + i">
                            <i v-if="tr.desglose[0]" class="far fa-arrow-alt-circle-down"></i>
                        </td>
                        <td>
                            <p class="mb-0" :style="cargosCancelados[i].includes('cancelado') ? 'color: #EE1313' : 'color: #212529'"><strong>{{tr.concepto}}</strong> <small>{{tr.subcategoria}}</small></p>
                            <md-menu  md-align-trigger v-if="(validarAcciones('aplicar-descuento-gestion', tr , true) || validarAcciones('parcializar-cargo-gestion', tr , true) || validarAcciones('cancelar-cargo-gestion', tr ,true) || tr.domiciliado == true)">
                                <button md-menu-trigger type="button" class="btn btn-sm" style="background: #F8F9F9 !important; color: #797D7F !important;">
                                    Acciones <i class="fas fa-sort-down ml-1"></i>
                                </button>
                                    <md-menu-content>
                                        <md-menu-item  v-if="validarAcciones('aplicar-descuento-gestion', tr , true)"   @click="activeDescuento = !activeDescuento; selectedRow = tr;"><span style="font-size: 14px;">Aplicar descuento</span></md-menu-item>

                                        <md-menu-item v-if="validarAcciones('parcializar-cargo-gestion', tr , true)"  @click="activeParcializar = !activeParcializar; selectedRow = tr;"><span style="font-size: 14px;">Parcializar cargo</span></md-menu-item>

                                        <md-menu-item v-if="permisos.includes('ver-gestion-finanzas') && cargoModificar == true" @click="activeEditarCargo =! activeEditarCargo; selectedRow = tr; tipoEditor = 'monto'"><span style="font-size: 14px;">Editar monto</span></md-menu-item>

                                        <md-menu-item v-if="validarAcciones('fecha-vencimiento-gestion', tr , true)"  @click="activeEditarFecha = !activeEditarFecha; selectedRow = tr;"><span style="font-size: 14px;">Editar fecha de vencimiento</span></md-menu-item>

                                        <md-menu-item v-if="tr.domiciliado == true" @click="activeDomicializacion = !activeDomicializacion; selectedRow = tr;"><span style="font-size: 14px;">Cancelar domiciliación</span></md-menu-item>

                                        <md-menu-item v-if="permisos.includes('ver-gestion-finanzas') && balance.tipo == 'cargo' && parseFloat(tr.cargo) < 0" @click="activeHuerfanos = !activeHuerfanos; selectedRow = tr;" ><span style="font-size: 14px;">Eliminar contracargos</span></md-menu-item>

                                        <!-- <md-menu-item v-if="permisos.includes('ver-gestion-finanzas')" @click="activeRevertir = !activeRevertir; selectedRow = tr;"><span style="font-size: 14px;">Revertir cancelación</span></md-menu-item> -->

                                        <md-menu-item v-if="validarAcciones('cancelar-cargo-gestion', tr ,true)"  @click="activeCancelacion = !activeCancelacion; selectedRow = tr;" style="border-top: 1px solid gray"><span style="font-size: 14px;">Cancelar cargo</span></md-menu-item>
                                    </md-menu-content>
                            </md-menu>  
                        </td>
                        <td>{{tr.vencimiento}}</td>
                        <td class="text-right">{{tr.cargo | currency}}</td>
                        <td></td>
                        <td class="text-right">{{tr.saldo | currency}}</td>
                    </tr>
                    <tr v-show="tr.desglose[0]" style="border: 1px solid #F2F3F4" v-for="(balance, j) in tr.desglose" :key="j" class="hide-table-padding">
                        <td :id="'collapseOne' + i"></td>
                        <td :id="'collapseOne' + i" class="collapse in p-3">
                            <p class="mb-0"><i>{{balance.concepto}} <small>{{balance.subcategoria}}</small></i></p>
                            <md-menu md-align-trigger>
                                
                                <button md-menu-trigger type="button" class="btn btn-sm" style="background: #F8F9F9 !important; color: #797D7F !important;">
                                    Acciones <i class="fas fa-sort-down ml-1"></i>
                                </button>
                                <md-menu-content>
                                    <md-menu-item  v-show="parseFloat(balance.abono) > 0" v-if="permisos.includes('desaplicar-beca-gestion') && balance.categoria === 'beca' && balance.beca_active == true && balance.facturado == false" @click="activeCancelacionPago = ! activeCancelacionPago; selectedRow = balance;">Desaplicar beca</md-menu-item>

                                    <md-menu-item  v-if="permisos.includes('ver-gestion-finanzas') && tr.saldo == 0 && balance.abono < 0 && tr.tipo == 'abono'" @click="activeEliminarPago = ! activeEliminarPago; selectedRow = tr; selectBalance = balance">Eliminar pagos cancelados</md-menu-item>

                                    <md-menu-item v-show="parseFloat(balance.abono) > 0" v-if="permisos.includes('ver-gestion-finanzas') && balance.categoria == 'rebaja'" @click="activeEliminarDescuento = ! activeEliminarDescuento; selectedRow = balance;">Eliminar descuento</md-menu-item>

                                    <md-menu-item v-show="parseFloat(balance.abono) > 0" v-if="permisos.includes('editar-concepto-gestion') && balance.categoria != 'rebaja'"  @click="getCancelarCambiar(balance)"><span style="font-size: 14px;">Editar concepto</span></md-menu-item>

                                    <md-menu-item v-if="permisos.includes('ver-gestion-finanzas') && institucion == 15 && balance.categoria !== 'beca'" @click="activeEditarCargo =! activeEditarCargo; selectedRow = balance; tipoEditor = 'abono'"><span style="font-size: 14px;">Editar monto</span></md-menu-item>

                                    <md-menu-item v-if="balance.factura && balance.factura.uuid  && balance.factura.uuid != ''" @click="activeCancelarFacturasolo =! activeCancelarFacturasolo; selectedRow = balance"><span style="font-size: 14px;">Cancelar <strong>factura</strong></span></md-menu-item>
                                    
                                    <md-menu-item v-if="balance.saldo > 0 && balance.categoria != 'beca'"  @click="activeTransladarSaldos = ! activeTransladarSaldos; selectedRow = balance;">Trasladar saldos</md-menu-item>

                                    <md-menu-item v-show="parseFloat(balance.abono) > 0" v-if="permisos.includes('devolucion-pagos-gestion') && balance.categoria !== 'rebaja' && balance.categoria !== 'beca' && balance.categoria !== 'descuento' && balance.factura.facturado != 'timbrado'" @click="activeDevolucion = ! activeDevolucion; selectedRow = balance;">Devolución</md-menu-item>

                                    <!-- <md-menu-item v-show="parseFloat(balance.abono) > 0" v-if="permisos.includes('cancelar-pago-gestion') && (balance.facturado == false || balance.factura.facturado == 'cancelado')" @click="activeCancelacionPago = !activeCancelacionPago; selectedRow = balance;"><span style="font-size: 14px;">Cancelar pago</span></md-menu-item> -->

                                    <md-menu-item v-show="parseFloat(balance.abono) > 0 && balance.factura.facturado != 'timbrado'" v-if="permisos.includes('cancelar-pago-gestion') && balance.categoria != 'rebaja'" @click="getCancelarPago(balance)"><span style="font-size: 14px;">Cancelar <strong>pago</strong></span></md-menu-item>

                                    <md-menu-item v-if="permisos.includes('ver-gestion-finanzas') && balance.tipo == 'cargo' && parseFloat(balance.abono) < 0" @click="activeHuerfanos = !activeHuerfanos; selectedRow = balance;" ><span style="font-size: 14px;">Eliminar contracargos</span></md-menu-item>

                                    <md-menu-item v-show="parseFloat(balance.abono) > 0" v-if="permisos.includes('cancelar-descuento-gestion') && balance.categoria === 'rebaja' && balance.categoria !== 'beca' && balance.facturado == false" @click="activeCancelacionPago = !activeCancelacionPago;  selectedRow = balance;"><span style="font-size: 14px;">Cancelar descuento</span></md-menu-item>
                                </md-menu-content>
                            </md-menu>
                        </td>
                        <td :id="'collapseOne' + i" class="collapse in p-3">
                            <div class="mb-1" v-if="balance.categoria !== 'rebaja' && balance.categoria !== 'beca'">
                                <div class="py-1" v-if="balance.factura.facturado == 'timbrado' || balance.factura.facturado == 'cancelado'">
                                    <strong><p class="text-uppercase mb-0">{{balance.factura.facturado}}</p></strong>
                                    <p class="mb-0"><small>MÉTODO DE PAGO</small></p>
                                    <p class="mb-0"><strong>{{balance.factura.metodo_pago}}</strong></p>
                                    <p class="mb-0"><small>UUID</small></p>
                                    <p class="mb-0"><strong>{{balance.factura.uuid}}</strong></p>
                                </div>
                                <div v-else>
                                    <strong><p class="text-uppercase mb-0">{{estatusFactura(balance.factura.status)}}</p></strong>
                                </div>
                                <div v-if="balance.autorizacion">
                                    <p class="mb-0"><small>AUTORIZACIÓN</small></p>
                                    <p class="mb-0"><strong>{{balance.autorizacion}}</strong></p>
                                </div>
                            </div>
                            <p class="mb-0"><small>FECHA DE PAGO</small></p>
                            <p class="mb-0"><strong>{{balance.vencimiento}}</strong></p>
                            <div style="display: flex">
                                <div style="width:50%;">
                                    <vs-tooltip>
                                        <vs-button v-if="balance.factura.uuid && balance.factura.facturado !== 'cancelado'"
                                            class="ml-auto mr-auto"
                                            icon
                                            color="success"
                                            flat
                                            :loading="loadingPDF"
                                            @click="getFactura(balance.movimiento_id ? balance.movimiento_id : '', balance.factura.uuid ? balance.factura.uuid : '')"
                                            
                                        >
                                            <i class="far fa-file-pdf fa-xs mini-icon mr-1"></i> PDF
                                        </vs-button>
                                        <template #tooltip>
                                            Descargar factura PDF
                                        </template>
                                    </vs-tooltip>
                                </div>
                                <div style="width:50%;">
                                    <vs-tooltip>
                                        <vs-button v-if="balance.factura.uuid && balance.factura.facturado !== 'cancelado'"
                                            class="ml-auto mr-auto"
                                            icon
                                            color="primary"
                                            flat
                                            :loading="loadingXML"
                                            @click="downloadXML(balance.movimiento_id ? balance.movimiento_id : '', balance.factura.uuid ? balance.factura.uuid : '')"
                                            
                                        >
                                            <i class="fas fa-file-download fa-xs mini-icon mr-1"></i> XML
                                        </vs-button>
                                        <template #tooltip>
                                            Descargar factura XML
                                        </template>
                                    </vs-tooltip>
                                </div>
                            </div>
                        </td>
                        <td :id="'collapseOne' + i" class="collapse in p-3">
                        </td>
                        <td :id="'collapseOne' + i" class="collapse in p-3 text-right">
                            <p class="mb-0"><strong>Abono total</strong></p>
                            <md-chip class="mini-chip col-yellow mb-3"><strong>{{balance.abono | currency}}</strong></md-chip>
                            <p class="mb-0"><strong>Abono aplicado</strong></p>
                            <md-chip class="mini-chip col-blue" ><strong>{{balance.abono_aplicado | currency}}</strong></md-chip>
                        </td>
                        <td :id="'collapseOne' + i" class="collapse in p-3 text-right">
                            {{balance.saldo | currency }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="tabName == 'saldo'">
            <saldo-favor :saldoFavor="trasladarSaldoFavor" :ciclosEscolares="ciclosEscolares" :cicloEscolar="cicloEscolar" :institucion="institucion" :personaId="personaId" @refreshTable="getRefresh"></saldo-favor>
        </div>
        <aplicar-descuento v-model="activeDescuento" :row="selectedRow" :persona-id="personaId" :ciclo-escolar="cicloEscolar" :institucion="institucion"  :nivel="nivel" :listPrograma="programas" :programa="programa" :programaId="programaId" @refreshTable="getRefresh"></aplicar-descuento>
        <parcializar-cargo v-model="activeParcializar" :row="selectedRow" :institucion="institucion" @refreshTable="getRefresh"  ></parcializar-cargo>
        <cancelar-cargo v-model="activeCancelacion" :row="selectedRow" :persona-id="personaId" :ciclo-escolar="cicloEscolar" :institucion="institucion" @refreshTable="getRefresh"></cancelar-cargo>
        <editar-cargo v-model="activeEditarCargo" :row="selectedRow" :institucion="institucion" :tipoEditor="tipoEditor" @refreshTable="getBalance"></editar-cargo>
        <cancelar-domicializar @refreshTable="getRefresh" :rows="selectedRow" :persona-id="personaId" v-model="activeDomicializacion" :ciclo-escolar="cicloEscolar" :institucion="institucion" :programa="programa"></cancelar-domicializar>

        <eliminar-huerfanos v-model="activeHuerfanos" :row="selectedRow"  @refreshTable="getRefresh"></eliminar-huerfanos>
        <revertir-cancelacion v-model="activeRevertir" :row="selectedRow"  @refreshTable="getRefresh"></revertir-cancelacion>
        <eliminar-descuento v-model="activeEliminarDescuento" :row="selectedRow"  @refreshTable="getRefresh"></eliminar-descuento>
        <cancelar-pago  v-model="activeCancelacionPago" :row="selectedRow" :persona-id="personaId" :ciclo-escolar="cicloEscolar" :institucion="institucion" @refreshTable="getRefresh"></cancelar-pago>
        <devolucion  v-model="activeDevolucion" :row="selectedRow" :persona-id="personaId" :ciclo-escolar="cicloEscolar" :institucion="institucion" @refreshTable="getRefresh"></devolucion>
        <editar v-model="activeEditarFecha" :row="selectedRow" :persona-id="personaId" :ciclo-escolar="cicloEscolar" :institucion="institucion" @refreshTable="getRefresh"></editar>
        <editar-pagos v-model="activeEditarPago" :row="selectedRow" :persona-id="personaId" :ciclo-escolar="cicloEscolar" :institucion="institucion" @refreshTable="getRefresh"></editar-pagos>
        
        <cambiar-concepto v-model="activeCambiarConcepto" :row="selectedRow" :institucion="institucion" :cicloEscolar="cicloEscolar" :personaId="personaId" :programa="programa" :programas="programas" :programaId="programaId" @changeConcepto="getRefresh"></cambiar-concepto>
        <cancelar-factura v-model="activeCancelarFactura" :row="selectedRow" :institucion="institucion" @changeConcepto="getAbrirCambiar" @abrirModal="abrirModalCancelar"></cancelar-factura>
        <cancelar-factura-pago v-model="activeCancelarFacturaPago" :row="selectedRow" :institucion="institucion" @refreshTable="getRefresh"></cancelar-factura-pago>
        <eliminar-pago v-model="activeEliminarPago" :row="selectedRow" :fila="selectBalance" @refreshTable="getRefresh"></eliminar-pago>

        <cancelar-facturasolo v-model="activeCancelarFacturasolo" :row="selectedRow" :institucion="institucion" @changeConcepto="getRefresh" :personaRol="personaRol"></cancelar-facturasolo>

        <transladar-saldos v-model="activeTransladarSaldos" :cicloEscolares="ciclosEscolares" :cicloEscolar="cicloEscolar" :institucion="institucion" :personaId="personaId" :row="selectedRow" @refreshTable="getRefresh"></transladar-saldos>
    </div>
</template>
<script>
import AplicarDescuento from './modales/aplicar-descuentos.vue'
import ParcializarCargo from './modales/parcializar-cargos.vue'
import CancelarCargo from './modales/cancelar-cargo.vue'
import CancelarPago from './modales/cancelar-pagos.vue'
import devolucion from './modales/devolucion.vue'
import profesor from '../../../api/requests/landing-profesor'
import editar from './modales/editar-fechas.vue'
import EditarPagos from './modales/editar-pagos.vue'
import EliminarHuerfanos from './modales/eliminar-huerfanos.vue'
import EliminarDescuento from './modales/eliminar-descuento.vue'
import RevertirCancelacion from './modales/revertir-cancelacion.vue'
import CambiarConcepto from './modales/cambiar-concepto-pago.vue'
import CancelarFactura from './modales/cancelar-factura.vue'
import CancelarFacturasolo from './modales/cancelar-factura-solo.vue'
import CancelarFacturaPago from './modales/cancelar-facturaPago.vue'
import EditarCargo from './modales/editar-cargo.vue'
import EliminarPago from './modales/eliminar-pago.vue'
import CancelarDomicializar from './modales/domicializar.vue'
import TransladarSaldos from './modales/mover-saldo.vue'
import cobranza from '../../../api/requests/cobranza-persona'
import SaldoFavor from './saldo-favor.vue'
    export default {
    props:[
        'permisos',
        'personaId',
        'parametros',
        'institucion',
        'instituciones',
        'institucionId',
        'cicloEscolar',
        'ciclosEscolares',
        'cicloEscolarId',
        'nivel',
        'programa',
        'programaId',
        'programas',
        'institucionNivel',
        'ejecutarAcciones',
        'ejecutarBalance',
        'personaRol',
        'proceso'
    ],
      data:() => ({
        balance:[],
        activeDescuento: false,
        activeParcializar: false,
        activeCancelacion: false,
        activeCancelacionPago: false,
        activeDevolucion: false,
        selectedRow: {},
        selectBalance: [],
        activeEditarFecha: false,
        activeHuerfanos: false,
        activeRevertir: false,
        activeEditarPago: false,
        activeEliminarDescuento: false,
        activeEditarConcepto: false,
        activeCambiarConcepto: false,
        activeCancelarFactura: false,
        activeCancelarFacturasolo: false,
        activeEditarCargo: false,
        activeEliminarPago: false,
        activeTransladarSaldos: false,
        refrescar: 0,
        activeCancelarFacturaPago: false,
        cargoModificar: false,
        activeDomicializacion: false,
        cargosCancelados: [],
        loadingPDF: false,
        loadingXML: false,
        tipoEditor: '',
        tabName: 'balance',
        saldoFavor: [],
        trasladarSaldoFavor: {},
        trasladarSaldoFavorGeneral: ''
      }),
      components:{
          AplicarDescuento,
          ParcializarCargo,
          CancelarCargo,
          CancelarPago,
          devolucion,
          editar,
          EliminarHuerfanos,
          RevertirCancelacion,
          EditarPagos,
          EliminarDescuento,
          CambiarConcepto,
          CancelarFactura,
          CancelarFacturasolo,
          CancelarFacturaPago,
          EditarCargo,
          EliminarPago,
          CancelarDomicializar,
          TransladarSaldos,
          SaldoFavor
      },
      methods:{
            estatusFactura(tipo){
                if(tipo == 'en_proceso_de_cancelacion'){
                    return 'En proceso de cancelación'
                }else if(tipo == 'cancelado'){
                    return 'Cancelada'
                }else{
                    return 'Sin timbrar'
                }
            },
            getIds(index){
                return 'balance' + index
            },
            abrirModalCancelar(){
                this.activeCancelarFacturasolo = true
            },
            getCancelarCambiar(balance){
                if(balance.factura.facturado == 'timbrado'){
                    this.activeCancelarFactura =! this.activeCancelarFactura
                }else if(balance.factura.facturado != 'timbrado'){
                    this.activeCambiarConcepto =! this.activeCambiarConcepto
                }
                this.selectedRow = balance
            },
            getCancelarPago(balance){
                if(balance.factura.facturado == 'timbrado'){
                    this.activeCancelarFacturaPago =! this.activeCancelarFacturaPago
                }else if(balance.factura.facturado != 'timbrado'){
                    this.activeCancelacionPago =! this.activeCancelacionPago
                }
                this.selectedRow = balance
            },
            getAbrirCambiar(balance){
                this.activeCambiarConcepto =! this.activeCambiarConcepto
                this.selectedRow = balance
            },
            getPagoCancelado(info){
                const cargos = []
                this.balance.forEach(i => {
                    const pagos = []
                    i.desglose.forEach(j => {
                        if(j.abono < 0){
                            pagos.push('cancelado')
                        }else{
                            pagos.push('activo')
                        }
                    })
                    cargos.push(pagos)
                })
                this.cargosCancelados = cargos
            },
            validarAcciones(perm ,row , sin_regla = false){
                let val = false
                if(row.categoria == 'servicio'){
                    val = Boolean(this.permisos.includes(perm))
                }else{
                    val = Boolean(this.permisos.includes(perm) && row.saldo  && row.saldo > 0 )
                }
                
                // if (row.tipo_servicio ){
                //     val = val && Boolean(row.tipo_servicio === 'requerido' ? true : false)
                //     if (sin_regla){
                //         val = val  && Boolean(row.origen_servicio && row.origen_servicio !== 'regla' ? true : false)
                //     }               
                // }

                return val
            },
            getRefresh(){
                // this.getBalance()
                this.$emit('refreshTable')

            },
            async getBalance(){
                if(this.cicloEscolar){
                    this.balance = []
                    // const loading = this.$vs.loading()
                    this.$emit("ejecutarLoading", true)
                    try {
                        const params = {
                            institucion: this.institucion,
                            ciclo_escolar: this.cicloEscolar,
                            programa: this.programa,
                            nivel_academico: this.nivel,
                            id: this.personaId
                        }
                        const { data: response } = await profesor.getBalance(params)
                        this.balance = response
                        this.getSaldoFavor()
                        this.getSaldoFavorTransladar()
                        this.getSaldoFavorTransladarGeneral()
                        // loading.close()
                        this.$emit("ejecutarLoading", false)
                    } catch (error) {
                        // loading.close()
                        this.$emit("ejecutarLoading", false)
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Hubo un error',
                            text: 'No se obtuvo información, favor de ponerse en contacto con el administrador.'
                        })
                    }
                }
            },
            async getSaldoFavor(){
                try{
                    const params = {
                        persona_id: this.personaId,
                        institucion_id: this.institucion,
                        ciclo_escolar_id: this.cicloEscolar
                    }
                    const { data: response } = await profesor.getSaldoFavor(params)
                    this.saldoFavor = response
                }catch(error){
                    console.log(error)
                }
            },
            async getSaldoFavorTransladar(){
                try{
                    const params = {
                        persona_id: this.personaId,
                        institucion_id: this.institucion,
                        ciclo_escolar_id: this.cicloEscolar,
                        type_response: 'detalle'
                    }
                    const { data: response } = await profesor.getSaldoFavorTransladar(params)
                    this.trasladarSaldoFavor = response
                }catch(error){
                    console.log(error)
                }
            },
            async getSaldoFavorTransladarGeneral(){
                try{
                    const params = {
                        persona_id: this.personaId,
                        institucion_id: this.institucion,
                        ciclo_escolar_id: this.cicloEscolar,
                        type_response: 'saldo_total'
                    }
                    const { data: response } = await profesor.getSaldoFavorTransladar(params)
                    this.trasladarSaldoFavorGeneral = response
                }catch(error){
                    console.log(error)
                }
            },
            getInstitutoNivel(){
                const array = this.institucionNivel
                array.forEach(element => {
                    console.log('id', element.id)
                    if(element.id == '5' || element.id == '6' || element.id == '9' || this.institucion == '11' || element.id == 4){
                        this.cargoModificar = true
                    }else{
                        this.cargoModificar = false
                    }
                });
            },
            
            async getFactura(m, uuid){
                this.loadingPDF = true
                try {
                    if (this.personaId){
                        const response = await cobranza.getFacturaTemp(this.personaId , m, uuid)
                        this.dowloadFile(response.data, response.headers)
                        this.loadingPDF = false
                    }
                } catch (error) {
                    if (error.response.data && error.response.data.errors){
                        this.loadingPDF = false
                        const data = error.response.data.errors
                        data.forEach(element => {
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Error',
                                text: element
                            })
                        });

                    }else{
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                        })
                    }
                }
            
            
            },
            async downloadXML(m, uuid){
                this.loadingXML = true
                try {
                    if (this.personaId){
                        const response = await cobranza.downloadXML(this.personaId , m, uuid)
                        this.dowloadFile(response.data, response.headers)
                        this.loadingXML = false
                    }
                } catch (error) {
                    if (error.response.data && error.response.data.errors){
                        this.loadingXML = false
                        const data = error.response.data.errors
                        data.forEach(element => {
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Error',
                                text: element
                            })
                        });

                    }else{
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                        })
                    }
                }
            },
            dowloadFile(blob, headers){
                if (blob instanceof Blob) {
                    const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    var filename = "";
                    const disposition = headers['content-disposition'];
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        const matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, '');
                            link.setAttribute('download', filename)
                        }
                    }
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }else{
                    throw { message: 'formatError' }
                }
            }
      },
      watch:{
          ejecutarBalance(){
              this.getBalance()
          },
          ejecutarAcciones(){
              this.getBalance()
          },
          balance(){
              this.refrescar += 1
              this.getPagoCancelado()
          },
          institucionNivel(){
              this.getInstitutoNivel()
          },
        //   cicloEscolar(){
        //       this.getBalance()
        //   }
      }
    }
</script>

<style scoped>

tr.hide-table-padding td {
  padding: 0;
}

.expand-button {
	position: relative;
}

.accordion-toggle .expand-button:after
{
  position: absolute;
  left:.75rem;
  top: 50%;
  transform: translate(0, -50%);
  content: '-';
}
.accordion-toggle.collapsed .expand-button:after
{
  content: '+';
}

.tableBalance td{
    border:0px !important;
}
.md-warn{
    background: #ffbc34;
    color: white;
    border-radius: 7px;
}

.widthCard{
    width: 30%;
    margin: 0 1.5%;
    @media only screen and (max-width: 768px) {
        width: 47%;
        margin: 1.5%;
    }
}

.md-danger{
    background: #f62d51;
    color: white;
    border-radius: 7px;
}

.md-dark{
    background: #19191a;
    color: white;
    border-radius: 7px;
}
</style>

<style lang="scss" scoped>
    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }
    
    .mayusculasSelect{
        text-transform: uppercase;
        cursor: pointer;
        margin: 0.5rem 1.3rem 0.5rem 0;
        color: #2471A3;
        border-bottom: 2px solid #2471A3;
    }

    .notSeleccionado{
        color: #CACFD2;
        text-transform: uppercase;
        cursor: pointer;
        margin: 0.5rem 1.3rem 0.5rem 0;
    }
</style>

        